export default "__VITE_ASSET__C9ltHF5B__"